import React, { useEffect, useRef, useState } from "react";

import { Box, Button, Grid, Tab, Tabs, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import HeaderLogo from "../img/headrlogo.png";
import styleCss from "../Style/style";
import SmallBus from "../img/smallbus.png";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import { QRCodeCanvas } from "qrcode.react";

import html2canvas from "html2canvas";

export default function BusTicketView({ ticket,showTicket, onClose }) {
  const ticketRef = useRef(null);
  const [downloaded, setDownloaded] = useState(false);
  console.log('callign')
  // if (!ticket) return null;

 useEffect(() => {

    if (!showTicket) {
      setTimeout(() => {
        handleDownload();
      }, 300);
    }
  }, [showTicket]);

  const {
    pnr_number,
    travel_date,
    total_amount,
    vehicle_operator_name,
    departure_time,
    booking_date,
  } = ticket;

  const seat_number = ticket?.passenger_details?.[0]?.seat_number;
  const boarding_point = ticket?.passenger_details?.[0]?.boarding_point;
  const dropping_point = ticket?.passenger_details?.[0]?.dropping_point;
  const passenger_name = ticket?.passenger_details?.[0]?.passenger_name;
  const passenger_age = ticket?.passenger_details?.[0]?.passenger_age;
  const passenger_gender = ticket?.passenger_details?.[0]?.passenger_gender;
  const boarding_time = ticket?.passenger_details?.[0]?.boarding_time;
  const dropping_time = ticket?.passenger_details?.[0]?.dropping_time;

  const handleDownload = async () => {
    const element = ticketRef.current;

    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`Ticket_${pnr_number}.pdf`);

     onClose();
  };
  return (
    <>
      <div ref={ticketRef}>
        <Box
          sx={{
            mt: 3,
            mx: 1.5,
            mb: 3,
            background: "white",
            border: "1px solid #e5e5e5",
            borderRadius: "16px",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              background: "linear-gradient(to right, #0284c7, #4f46e5)",
              p: 2,
              display: "flex",
              alignItems: "center",
              color: "white",
            }}
          >
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                flex: 1,
                textAlign: "left",
              }}
            >
              {vehicle_operator_name}
            </Typography>

            <Grid
              size={{ xs: 6, md: 3 }}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <img
                src={HeaderLogo}
                alt="Header Logo"
                style={styleCss.HeaderLogosize}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img src={SmallBus} alt="Small-bus" />
              </Box>
            </Grid>

            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 600,
                flex: 1,
                textAlign: "right",
              }}
            >
              PNR: {pnr_number}
            </Typography>
          </Box>

          <Box
            sx={{
              width: "100%",
              mt: 3,
              mb: 3,  
              px: 4,
              background: "white",
              overflow: "hidden",
            }}
          >
            <Grid container spacing={6}>
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "grid", gap: 1.5 }}>
                  <Row
                    label="Passenger"
                    value={`${passenger_name} (${passenger_age}/${passenger_gender})`}
                  />
                  <Row label="Fare" value={`₹${total_amount}`} />
                  <Row label="Boarding" value={boarding_point} />
                  <Row label="Dropping" value={dropping_point} />
                  <Row label="Date" value={travel_date} />
                </Box>
              </Grid>

              <Grid
                item
                md={0.1}
                sx={{
                  display: { xs: "none", md: "block" },
                  borderLeft: "2px solid #e5e5e5",
                }}
              />

              <Grid item xs={12} md={6}>
                <Box sx={{ display: "grid", gap: 1.5 }}>
                  <Row label="Departure" value={departure_time} />
                  <Row label="Boarding Time" value={boarding_time} />
                  <Row label="Dropping Time" value={dropping_time} />
                  <Row label="Seat" value={seat_number} />
                  <Row label="Booking Date" value={booking_date} />
                </Box>
              </Grid>
              <Grid item xs={12} md={2}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <QRCodeCanvas
                    value={`PNR: ${pnr_number}Date: ${travel_date}Passenger: ${passenger_name}Seat: ${seat_number}Boarding: ${boarding_point}Dropping: ${dropping_point}`}
                    size={180}
                    includeMargin
                  />{" "}
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              background: "linear-gradient(to right, #0284c7, #4f46e5)",
              p: 2,
              display: "flex",
              alignItems: "center",
              color: "white",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 300,
                flex: 1,
                textAlign: "left",
                ml: 2,
              }}
            >
              Note: Please arrive 15 minutes before departure.
            </Typography>
          </Box>
        </Box>
      </div>
      {!downloaded && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", px: 4, pb: 2 }}>
          <Button
            variant="outlined"
            onClick={handleDownload}
            sx={{
              fontFamily: '"Segoe UI", sans-serif',
              fontSize: "13px",
              color: "#0e182b",
              textTransform: "capitalize",
              borderRadius: "6px",
              border: "solid 1px #e5e5e5",
            }}
          >
            Download
          </Button>
        </Box>
      )}
    </>
  );
}

function Row({ label, value }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography sx={{ fontWeight: 600 }}>{label}:</Typography>
      <Typography>{value}</Typography>
    </Box>
  );
}
